<template>
  <div class="box">
    <div class="newsinfo">
      <div class="top">
        <router-link to="/">首页</router-link>><span>编制出版<span v-if="title!='联系我们'">>{{articles.contentName}}</span></span>
      </div>
      <div class="title">
        <h2>{{articles.contentName}}</h2>
        <p>{{articles.author}}</p>
        <div>
            <span class="company">{{articles.company}}</span>
          <span class="addtime">{{articles.addtime|filterDate}}</span>
          <span style="float: right;margin-right: 56px;">浏览：{{articles.artvisits}}</span>
        </div>
      </div>
      <div class="contentinfo" >
        <p class="summary">
            <span class="sumtitle">摘&nbsp;&nbsp;&nbsp;&nbsp;要：</span>
            {{articles.summary}}
        </p>
         <p class="keyword">
            <span class="keytitle">关键词：</span>
            {{articles.keyWords}}
        </p>
      </div>
      <div v-if="articles.fileSrc=='NoLogin'" class="nologin">
        <p>
            以下内容，仅对会员开放。如需查看详细内容，请先<span class="goreg" @click="$router.push('/userreg')"> 注册 </span>成为会员，已注册会员请<span class="golog" @click="$router.push('/userlogin')"> 登录 </span>后查看。
        </p>
        
      </div>
      <div v-else-if="articles.fileSrc"  class="contentinfo">
        <iframe  :src="`/pdfview?file=/uploads/bookFile/${articles.fileSrc}`"></iframe>
      </div>
      
    </div>
  </div>
</template>

<script>
import { getBookArt } from '@/request/get'
export default {
  name: "BookArtShow",
  components: {
  },
  data() {
    return {
      bookArtId: this.$route.params.bookArtId || '',
      articles: {
        addtime: "",
        title:"",
        description:"",
        keywords:""
      }
    }
  },
  filters: {
    filterDate(date) {
      return date.slice(0, 10);
    }
  },
  computed: {
    title() {
      let { plates } = this.$store.state;
      let arrs = plates.filter(item => item.uuid == this.plateId)
      return arrs.length === 0 ? "未配置" : arrs[0].name
    }
  },
  created() {
    this.getNewsInfo();
  },
  mounted() {
    this.toTop();
  },
  methods: {
    async getNewsInfo() {
       let result = await getBookArt(this.bookArtId);
      this.articles = result.data;
    //   if (!this.articles.addtime) {
        let addtime = this.articles.createdAt;
        let date = new Date(addtime);
        this.articles.addtime = `${date.getFullYear()}-${("00" + (date.getMonth() + 1)).slice(-2)}-${("00" + date.getDate()).slice(-2)} ${("00" + date.getHours()).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${("00" + date.getSeconds()).slice(-2)}`
    //   }
    },
    
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style scoped>
.box{
  position: relative;
  width: 100%;
  background-color: #fff;
}
.newsinfo{
  position: relative;
  width: 1300px;
  min-height: 1245px;
  margin: 0 auto;
  overflow: hidden;
}
.newsinfo>.top{
  position: relative;
  margin-top: 27px;
  height: 16px;
  font-size: 16px;

  font-weight: 500;
  color: #333;
  line-height: 16px;
}
.newsinfo>.title{
  position: relative;
  height: 56px;
  padding: 49px 0 61px;
  border-bottom: 1px solid #EFEFEF;
  margin-bottom: 14px;
}
.newsinfo>.title>h2{
  font-size: 22px;

  font-weight: bold;
  color: #306BCD;
  line-height: 22px;
  text-align: center;
}
.newsinfo>.title>div {
  position: absolute;
  /* right: 5px; */
  bottom: 14px;
      width: 100%;
}
.newsinfo>.title>div>span{
  height: 14px;
  font-size: 14px;

  font-weight: 500;
  color:#333333;
  line-height: 14px;
}
.newsinfo>.title>div>span.addtime{
  display: inline-block;
  padding-right: 47px;
  float: right;
}
.newsinfo>.contentinfo{
  margin-left:8px;
  width: 1162px;
  /* min-height: 463px; */
  font-size: 14px;

  font-weight: 500;
  color: #333333;
  line-height: 28px;
}
iframe{
  width: 100%;
    height: 800px;
}
.title>p{
    text-align: center;
    margin-top: 16px;
    margin-bottom: 20px;
    font-size: 12px;
    color: rgb(1, 78, 92);
}
.company{
    color: #333333 !important;

}
.nologin>p{
    line-height: 100px;
    text-align: center;
    font-size: 21px;
    color: #138839;
}
.goreg{
    color: red;
}
.golog{
    color: red;
}
.nologin{
        width: 100%;
    height: 100px;
    background-color: #e6e6e6;
}
.keyword>.keytitle{
    font-weight: 900;
}
.keyword{
        line-height: 21px;
        margin-top: 10px;
        margin-bottom: 30px;
}
.summary>.sumtitle{
    font-weight: 900;
}
.summary{
        line-height: 21px;
}
</style>
